module.exports = __webpack_public_path__ + "img/circle-half.a974f392.svg";